"use client";

import { useState } from 'react';

export default function SettingsPage() {
  const [profile, setProfile] = useState({
    name: "Andrej K.",
    email: "andrej@fotoforensics.si",
    company: "Forenzika d.o.o.",
    notifications: true
  });
  const [saving, setSaving] = useState(false);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      alert("Nastavitve uspešno shranjene!");
    }, 800);
  };

  return (
    <main className="container animate-fade-in">
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
        <h2 style={{margin: 0}}>Nastavitve Profila</h2>
        <div className="token-badge">
          <span>🪙</span> 450 Žetonov
        </div>
      </div>

      <div className="dashboard-grid" style={{ gridTemplateColumns: '1fr 300px' }}>
        
        {/* Profile Settings */}
        <div className="glass-card">
          <h3 style={{marginBottom: '1.5rem'}}>Osebni Podatki</h3>
          <form onSubmit={handleSave}>
            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', marginBottom: '0.5rem', color: '#a0a0a0', fontSize: '0.9rem'}}>Ime in priimek</label>
              <input 
                type="text" 
                value={profile.name}
                onChange={e => setProfile({...profile, name: e.target.value})}
                style={{
                  width: '100%', padding: '0.75rem', borderRadius: '8px', 
                  background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', 
                  color: 'white', fontSize: '1rem', boxSizing: 'border-box'
                }} 
              />
            </div>
            
            <div style={{marginBottom: '1.5rem'}}>
              <label style={{display: 'block', marginBottom: '0.5rem', color: '#a0a0a0', fontSize: '0.9rem'}}>E-poštni naslov</label>
              <input 
                type="email" 
                value={profile.email}
                onChange={e => setProfile({...profile, email: e.target.value})}
                style={{
                  width: '100%', padding: '0.75rem', borderRadius: '8px', 
                  background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', 
                  color: 'white', fontSize: '1rem', boxSizing: 'border-box'
                }} 
              />
            </div>

            <div style={{marginBottom: '2rem'}}>
              <label style={{display: 'block', marginBottom: '0.5rem', color: '#a0a0a0', fontSize: '0.9rem'}}>Podjetje</label>
              <input 
                type="text" 
                value={profile.company}
                onChange={e => setProfile({...profile, company: e.target.value})}
                style={{
                  width: '100%', padding: '0.75rem', borderRadius: '8px', 
                  background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', 
                  color: '#9ca3af', fontSize: '1rem', boxSizing: 'border-box'
                }} 
                disabled
              />
              <p style={{fontSize: '0.8rem', color: '#6b7280', marginTop: '0.5rem'}}>Za spremembo podjetja se obrnite na administratorja.</p>
            </div>

            <h3 style={{marginBottom: '1.5rem', marginTop: '2rem'}}>Obvestila in Zasebnost</h3>
            <label style={{display: 'flex', alignItems: 'center', gap: '1rem', cursor: 'pointer', marginBottom: '2rem'}}>
              <input 
                type="checkbox" 
                checked={profile.notifications}
                onChange={e => setProfile({...profile, notifications: e.target.checked})}
                style={{width: '1.2rem', height: '1.2rem', cursor: 'pointer'}}
              />
              <span style={{color: '#e5e7eb'}}>Prejemaj obvestila o novih funkcijah in posodobitvah</span>
            </label>

            <button type="submit" className="btn-primary" style={{padding: '0.8rem 2rem'}} disabled={saving}>
              {saving ? 'Shranjevanje...' : 'Shrani spremembe'}
            </button>
          </form>
        </div>

        {/* Side Panel for Tokens & API */}
        <div style={{display: 'flex', flexDirection: 'column', gap: '1.5rem'}}>
          <div className="glass-card delay-1" style={{padding: '1.5rem'}}>
            <h4 style={{marginBottom: '1rem', color: '#e5e7eb'}}>Stanje Žetonov</h4>
            <div style={{fontSize: '2.5rem', fontWeight: 700, color: '#e0e0e0', marginBottom: '0.5rem'}}>450</div>
            <p style={{color: '#a0a0a0', fontSize: '0.85rem', marginBottom: '1.5rem'}}>
              Ena analiza porabi 1 žeton. Za zakup novih žetonov kontaktirajte podporo.
            </p>
            <button className="btn-primary" style={{width: '100%', fontSize: '0.9rem', padding: '0.6rem'}}>
              Naroči žetone
            </button>
          </div>

          <div className="glass-card delay-2" style={{padding: '1.5rem'}}>
            <h4 style={{marginBottom: '1rem', color: '#e5e7eb'}}>API Dostop</h4>
            <p style={{color: '#a0a0a0', fontSize: '0.85rem', marginBottom: '1rem'}}>
              Vaš API ključ je skrit iz varnostnih razlogov.
            </p>
            <div style={{
              background: 'rgba(0,0,0,0.3)', padding: '0.75rem', borderRadius: '8px', 
              color: '#9ca3af', fontSize: '0.85rem', letterSpacing: '2px', marginBottom: '1rem',
              textAlign: 'center'
            }}>
              sk-live-••••••••••••
            </div>
            <button style={{
              background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'white',
              padding: '0.5rem', width: '100%', borderRadius: '8px', cursor: 'pointer', fontSize: '0.85rem',
              transition: 'all 0.2s'
            }}>
              Generiraj nov ključ
            </button>
          </div>
        </div>

      </div>
    </main>
  );
}
